import { ITaskRawQuery } from '@models/Task.model';
import { CreateTaskDialogQuery } from './CreateTaskDialog.query';

interface ICreateTaskDialog {
  open: boolean;
  onClose: () => void;
  task?: ITaskRawQuery;
}

export const CreateTaskDialog = (props: ICreateTaskDialog) => {
  return <CreateTaskDialogQuery {...props} />;
};
